<template>
	<div class="login_box">
		<div class="p_flex p_box ">
			<div class="one_left">
				<div class="one_left-tiw"><img style="width: 100%;height: 100%;" src="../../assets/img/Boss_Two Color.png" /></div>
			</div>
			<div class="one_two  ">
				<div><span class="p_flex p_m_a_a p_m_a_b subject_color type_size_30 ">密保找回</span></div>
				<div class="two_box">
					<div>
						<div class="type_size_18 p_flex">
							<span class="p_m_l_30">问题一</span>
							<span class="p_m_l_30">{{ one }}</span>
						</div>
						<div class="p_flex p_login p_f_a p_m_t_20">
							<span class="p_m_l_30 type_size_18 ">回答一</span>
							<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="account1" placeholder="请输入答案"></el-input></div>
						</div>
					</div>
					<div class="p_m_t_30">
						<div class="type_size_18 p_flex">
							<span class="p_m_l_30">问题二</span>
							<span class="p_m_l_30">{{ tow }}</span>
						</div>
						<div class="p_flex p_login p_f_a p_m_t_20">
							<span class="p_m_l_30 type_size_18 ">回答二</span>
							<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="account2" placeholder="请输入答案"></el-input></div>
						</div>
					</div>
					<div class="p_m_t_30">
						<div class="type_size_18 p_flex">
							<span class="p_m_l_30">问题三</span>
							<span class="p_m_l_30">{{ three }}</span>
						</div>
						<div class="p_flex p_login p_f_a p_m_t_20">
							<span class="p_m_l_30 type_size_18 ">回答三</span>
							<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="text" v-model="account3" placeholder="请输入答案"></el-input></div>
						</div>
					</div>
				</div>
				<div class="" style="margin-top: 10%;">
					<div class="two_com "><el-button type="success" @click="goLogin()">确认</el-button></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Security',
	data() {
		return {
			account1: '',
			account2: '',
			account3: '',
			one: '',
			tow: '',
			three: '',
			id: '',
			id1: '',
			id2: '',
			id3: ''
		};
	},
	created() {
		this.id = localStorage.getItem('userInfo');
		this.$request
			.ajax(this)
			.post('/api/security_question', {
				account: this.$route.query.id,
				user_type: this.id == 0 ? 'teacher' : 'student'
			})
			.then(res => {
				//   console.log(res)
				this.one = res.data[0].problem;
				this.tow = res.data[1].problem;
				this.three = res.data[2].problem;
				this.id1 = res.data[0].id;
				this.id2 = res.data[1].id;
				this.id3 = res.data[2].id;
			});
	},
	methods: {
		goLogin() {
			this.$request
				.ajax(this)
				.post('/api/forget_secret', {
					account: this.$route.query.id,
					user_type: this.id == 0 ? 'teacher' : 'student',
					one: { id: this.id1, answer: this.account1 },
					two: { id: this.id2, answer: this.account2 },
					three: { id: this.id3, answer: this.account3 }
				})
				.then(res => {
					// console.log(res)
					this.$router.push({
						//修改密码
						path: 'Amend',
						query: {
							id: res.data
						}
					});
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.one_left {
	width: 50%;
	background-color: #fafafa;
	border-radius: 20px 0px 0px 20px;
}
.one_left .one_left-tiw {
	width: 80%;
	margin: 15% auto 0;
}

.p_m_a_a{
	margin-top: 10%;
}

.p_m_a_b{
	margin-left: 15%;
}

.p_m_a_c{
	margin-left: 5%;
}


.p_m_a_d{
	margin-right: 5%;
}

.two_box{
	width: 70%;
	margin: 10% auto 0;
}

.p_login{
	width: 100%;
}

.one_two {
	 width: 50%;
	background: #ffffff;
	border-radius: 0px 20px 20px 0px;
}

.p_m_t_a{
	margin-top: 20%;
}

.p_m_t_b{
	margin-top: 15%;
}

.two_com {
	width: 50%;
	margin: 0 auto;
}

.two_log {
	width: 40%;
	margin: 10% auto 0;
	// background: #0000FE;
	// margin: 100px auto 0;
}

.el-button--success {
	width: 100%;
	margin: 0 auto;
}
.el-button {
	border-radius: 20px;
	font-size: 22px;
	padding: 20px;
}
.footer {
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}
.login_box {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 60%;
	height: 85%;
}
img {
	width: 100%;
	height: auto;
	object-fit: cover;
}
.p_box{
	width: 100%;
	height: 90%;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}


.footer{
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}



>>> input::-webkit-input-placeholder {
	font-size: 18px;
}

>>> input::-webkit-outer-spin-button,
>>> input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

>>> input[type='number'] {
	-moz-appearance: textfield;
}


.yan_code {
	color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/login/security.vue